import React from 'react';
const AuthUserContext = React.createContext(null);
console.log(AuthUserContext)
export default AuthUserContext;
